import { ArrowRight } from "lucide-react";

const CallToAction = () => {
  return (
    <section id="contact" className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-benchr-700 to-benchr-900 opacity-95 -z-10" />
      
      {/* Background elements */}
      <div className="absolute top-0 left-0 w-full h-full -z-10">
        <div className="absolute top-1/4 right-1/4 w-[600px] h-[600px] bg-benchr-500/30 rounded-full blur-3xl" />
        <div className="absolute bottom-1/3 left-1/3 w-[500px] h-[500px] bg-benchr-600/20 rounded-full blur-3xl" />
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 tracking-tight animate-slide-up">
            Ready to Gain a Competitive Edge in E-commerce?
          </h2>
          <p className="text-xl text-benchr-100 mb-4 leading-relaxed animate-slide-up" style={{ animationDelay: "100ms" }}>
            Start uncovering actionable insights about your competitors today with our 14-day free trial.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12 animate-slide-up" style={{ animationDelay: "200ms" }}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.open(
                  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ0ixREziCGTZSnjXhuPB0TBIti2X5Ks-ATre2wgAkuMuHqJ4XWW7hldUQxV7WW_GMwHwd9IwfBm?gv=true',
                  'BookADemo',
                  'width=1400,height=900'
                );
              }}
              className="group inline-flex items-center justify-center px-6 py-3.5 bg-[#1e70d1] hover:bg-[#1e70d1]/90 text-white font-medium rounded-lg shadow-sm hover:shadow-md transition-all duration-300 ease-in-out w-full sm:w-auto pulse-soft"
            >
              Book a Demo
              <ArrowRight size={18} className="ml-2 transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
